import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import { addTranslation, IntlProps } from 'decorators/addTranslation';
import { WithRouterProps } from 'decorators/withRouter';
import { StoreProps } from 'store';

import TopPanelContainer from 'components/topPanel';
import DataListContainer from 'components/dataListContainer';
import { Column, Row } from 'components/ui/table';
import Button from 'components/ui/button';

import getConfigurationByName from 'selectors/getConfigurationByName';
import quickFiltersConfig from './quickFiltersConfig';
import tableNames from 'constants/tableNames';
import { AnyObject } from 'types/Common';
import PageTemplate from 'components/pageTemplate/PageTemplate';
import { openModal } from 'actions/modal';
import { getBalanceManageList } from 'api/balanceManage';

interface ConnectedProps {
  configuration: AnyObject;
}

type Props = ConnectedProps & StoreProps & IntlProps & WithRouterProps;

const BalanceManageContainer = (props: Props) => {
  const {
    configuration,
    getTranslate,
    dispatch,
  } = props;

  const openCreateModal = useCallback((content?) => {
    dispatch(openModal({
        modalId: 'TransferMoney',
        content,
      })
    );
  }, [dispatch]);

  const renderRow = useCallback((data) => {
    return (
      <Row>
        {configuration.map((config) => {
          const { id } = config;
          let content = data[id];

          return (
            <Column
              columnWidths={data.columnWidths}
              key={id}
              id={id}
              content={content}
              customClass={classNames(`ui-table__column_${id}`, {
                'ui-table__column_fixed': config.fixed,
              })}
              params={{
                ...config,
                valueId: config.id,
                valueType: config.valueType,
              }}
            />
          );
        })}
      </Row>
    );
  }, [configuration]);

  return (
    <PageTemplate.Main topPadding>
      <PageTemplate.Container customClass={'page-balanceManage'}>
        <TopPanelContainer
          name={tableNames.balanceManage}
          isFilterButton={false}
          isConfigurationButton={true}
          button={
            <Button
              status='primary'
              onClick={openCreateModal}
              text={getTranslate('balanceManage.modal.transferMoney')}
            />
          }
          filtersConfig={quickFiltersConfig}
        />
        <DataListContainer
          tableName={tableNames.balanceManage}
          customClass='table-balanceManage'
          apiRequest={getBalanceManageList}
          rowRender={renderRow}
        />
      </PageTemplate.Container>
    </PageTemplate.Main>
  );
};

const mapStateToProps = (state): ConnectedProps => ({
  configuration: getConfigurationByName(state, tableNames.balanceManage),
});

export default withRouter(
  connect(mapStateToProps)(addTranslation(BalanceManageContainer))
);
